const regions = {
  "Nord- och Sydamerika": [
    "Uruguay",
    "Venezuela",
    "United States of America",
    "United States",
    "Canada",
    "Mexico",
    "Panama",
    "Guatemala",
    "Honduras",
    "Costa Rica",
    "El Salvador",
    "Nicaragua",
    "Cuba",
    "Dominican Republic",
    "Dominica",
    "Jamaica",
    "Trinidad and Tobago",
    "Barbados",
    "Bahamas",
    "Saint Lucia",
    "Saint Vincent and Grenadines",
    "Saint Kitts and Nevis",
    "Grenada",
    "Antigua and Barbuda",
    "Saint Pierre and Miquelon",
    "Bermuda",
    "Cayman Islands",
    "Anguilla",
    "Montserrat",
    "Turks and Caicos Islands",
    "Puerto Rico",
    "U.S. Virgin Islands",
    "Aruba",
    "Curaçao",
    "Saint Martin (Fr.)",
    "Sint Maarten",
    "Colombia",
    "Guyana",
    "Peru",
    "Bolivia",
    "Paraguay",
    "Chile",
    "Ecuador",
    "Brazil",
    "Argentina",
    "Falkland Islands",
    "Suriname",
    "Haiti",
    "Greenland",
    "Newfoundland",
    "Cook Islands",
    "Niue",
    "S. Geo. and the Is.",
    "Pitcairn Is.",
    "Falkland Is.",
    "Cayman Is.",
    "British Virgin Is.",
    "Turks and Caicos Is.",
    "Jersey",
    "Guernsey",
    "Isle of Man"
  ],

  "Större Asien": [
    "Yemen",
    "Vietnam",
    "Uzbekistan",
    "Myanmar",
    "Cambodia",
    "Thailand",
    "Taiwan",
    "Timor-Leste",
    "Syria",
    "South Korea",
    "Japan",
    "Palestine",
    "Israel",
    "Jordan",
    "Pakistan",
    "North Korea",
    "Philippines",
    "Nepal",
    "Kyrgyzstan",
    "Kazakhstan",
    "Iran",
    "Iraq",
    "Indonesia",
    "India",
    "Malaysia",
    "Maldives",
    "Macao",
    "Hong Kong",
    "Brunei",
    "Bahrain",
    "Bangladesh",
    "Afghanistan",
    "Armenia",
    "Turkey",
    "Tajikistan",
    "Saudi Arabia",
    "Qatar",
    "United Arab Emirates",
    "Oman",
    "Kuwait",
    "Azerbaijan",
    "Turkmenistan",
    "Sri Lanka",
    "Bhutan",
    "China",
    "Mongolia",
    "Russia",
    "Malta",
    "Singapore"
  ],

  "Större Europa": [
    "United Kingdom",
    "Ukraine",
    "Switzerland",
    "Sweden",
    "Romania",
    "Poland",
    "Portugal",
    "France",
    "Germany",
    "Italy",
    "Netherlands",
    "Belgium",
    "Luxembourg",
    "Lithuania",
    "Latvia",
    "Estonia",
    "Finland",
    "Norway",
    "Iceland",
    "Ireland",
    "Denmark",
    "Spain",
    "Greece",
    "Slovakia",
    "Slovenia",
    "Austria",
    "Czechia",
    "Bulgaria",
    "Serbia",
    "Croatia",
    "Kosovo",
    "Moldova",
    "Albania",
    "Andorra",
    "Monaco",
    "Cyprus",
    "Georgia",
    "Belarus",
    "Montenegro",
    "North Macedonia",
    "San Marino",
    "Liechtenstein",
    "Vatican",
    "Åland Islands",
    "Bosnia and Herz.",
    "Malta"
  ],

  "Afrika": [
    "Uganda",
    "Tunisia",
    "eSwatini",
    "South Africa",
    "Botswana",
    "Sierra Leone",
    "Senegal",
    "São Tomé and Principe",
    "Rwanda",
    "Nigeria",
    "Niger",
    "Namibia",
    "Morocco",
    "W. Sahara",
    "Mali",
    "Madagascar",
    "Libya",
    "Liberia",
    "Lesotho",
    "Guinea-Bissau",
    "Guinea",
    "Ghana",
    "Gambia",
    "Gabon",
    "Ethiopia",
    "Eritrea",
    "Eq. Guinea",
    "Egypt",
    "Djibouti",
    "Côte d'Ivoire",
    "Dem. Rep. Congo",
    "Congo",
    "Comoros",
    "Chad",
    "Central African Rep.",
    "Cabo Verde",
    "Cameroon",
    "Burkina Faso",
    "Benin",
    "Burundi",
    "Togo",
    "Seychelles",
    "Mauritania",
    "Mauritius",
    "Malawi",
    "Zimbabwe",
    "Zambia",
    "Somalia",
    "Solomon Islands"
  ]
};

export default regions;